<script setup>
import VueMultiselect from "vue-multiselect";
import useAutocompleter from "@/composables/useAutocompleter";
import {useSlots} from "vue";

const props = defineProps({
    value: {
        type: [Object, Array, null],
        default: null,
    },
    getListMethod: Function,
    placeholder: String,
    excludeIds: {
        type: Array,
        default: () => [],
    },
    multiple: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['input']);
const {model, list, updateList} = useAutocompleter(props, emit);
const slots = useSlots();

</script>

<template>
    <VueMultiselect
        v-model="model"
        :placeholder="placeholder"
        :options="list"
        select-label=""
        deselect-label=""
        :multiple="multiple"
        label="name"
        track-by="name"
        class="multiselect-mid pl-2"
        @search-change="updateList"
    >
        <template v-if="slots.option" #option="props">
            <slot name="option" v-bind="props"/>
        </template>
    </VueMultiselect>
</template>

<style scoped>

</style>
